<template>
  <v-dialog v-model="show" max-width="800px" :fullscreen="isMobile">
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>Uppgifter från BookVisit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-4">
        <pre class="bookvisit-information-text">{{ bookvisitInformation }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="bookvisitBookingCode"
          color="primary"
          @click="openBookvisitReservation"
        >
          <v-icon left>mdi-open-in-new</v-icon>
          Öppna i BookVisit
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">
          Stäng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .bookvisit-information-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.87);
  }
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BookvisitInformationDialog',
  props: {
    value: Boolean,
    bookvisitInformation: String,
    bookvisitBookingCode: String
  },
  computed: {
    ...mapState(
      {
        isElectron: state => state.isElectron
      }
    ),
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    close () {
      this.show = false
    },
    openBookvisitReservation () {
      const bookingCode = this.bookvisitBookingCode
      if (bookingCode) {
        const url = `https://admin.bookvisit.com/Reservation/managereservation?BookingNumberOrCustomerName=${bookingCode}`
        if (this.isElectron) {
          window.shell.openExternalLink(url)
        } else {
          window.open(url, '_blank')
        }
      }
    }
  }
}
</script>
